import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IResourceCostRepository } from "./IResourceCostRepository";
import { ResourceCost } from "src/app/models/Production/resource-cost";

@Injectable(
    {
        providedIn: "root"
    }
)
export class ResourceCostRepository extends GenericRepository<ResourceCost> implements IResourceCostRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/ResourceCost', environment.urlAddress);
    }

    GetRec(resourceCostCode: string): Observable<any> {
        return this.Get('/GetRec' + '/' + resourceCostCode).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this.Get('/SelectAll' + '/' + currentPage + '/' + recordsPerPage).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(item: ResourceCost): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
}